<template>
  <base-layout>
    <div class="common-page new-card">
      <div class="container-fluid">
        <h1 class="common-page__main-title">{{ $t('newCard') }}</h1>
        <dx-card-form
          ref="form"
          :disabled="sending"
          @submit="onSubmit"
          />
      </div>
    </div>
  </base-layout>
</template>

<script>
import { mapActions } from 'vuex'
import { BaseLayout } from '../layouts'
import { DxCardForm } from '../components'
export default {
  name: 'new-card',
  components: {
    BaseLayout,
    DxCardForm
  },
  data () {
    return {
      sending: false
    }
  },
  methods: {
    ...mapActions([
      'createCard'
    ]),
    onSubmit (data) {
      if (!this.sending) {
        this.sending = true
        this.createCard(data).then((result) => {
          if (result) {
            this.$refs.form.cleanData()
          }
          this.sending = false
        }).catch(() => {
          this.sending = false
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/NewCard.vue